<template>
  <div>
    <div class="g-banner">
      <cmpBanner bannerType="10"></cmpBanner>
    </div>
    <div class="list-box list1 g-pad-top">
      <div class="item g-card-2" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
        <!-- <div class="pic-box">
            <img v-lazy="item.picUrl" alt="">
          </div> -->
        <div class="g-border-box white">
          <div class="g-border">
            <div class="info">
              <div>
                <h2>{{ item.title }}</h2>
                <p class="time m-font-2">{{ item.createTimeStr }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cmpMyPagination :currentPage="listQuery.currentPage" :pageSize="listQuery.size" :total="total"
      @eventPage="eventPage"></cmpMyPagination>
  </div>
</template>

<script>
export default {

  data() {
    return {
      listQuery: {
        currentPage: 1,
        size: 6,
      },
      total: 0,
      dataList: []
    };
  },

  mounted() {
    this.getInfoList()
  },

  methods: {
    getInfoList() {
      this.$http.get('../singleMuseum/webapi/notice', {
        ...this.listQuery
      }).then(res => {
        if (res.success) {
          this.dataList = res.result
          this.total = res.page.allRow
        }
      })
    },



    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      this.listQuery.size = obj.size
      this.getInfoList()
    },

    goDetail(obj) {
      this.$router.push({
        path: '/notice/detail',
        query: { id: obj.id, pageType: obj.uniqueName }
      })
      // if (obj.fileIds) {
      //   let pdfUrl = obj.fileList && obj.fileList[0].attPath
      //   window.open(pdfUrl, '_blank')
      // } else {
      //   this.$router.push({
      //     path: '/notice/detail',
      //     query: { id: obj.id, pageType: obj.uniqueName }
      //   })
      // }
    },

  },
};
</script>

<style lang="scss" scoped>
.list1 {
  width: 1600px;
  margin: 0 auto;

  .item {
    padding: 20px 0;
    margin: 0;
    border-bottom: 1px solid rgba($color: #312f2e, $alpha: 0.2);

    &:first-child {
      border-top: solid 1px $primary;
    }

    &:last-child {
      border-color: $primary;
    }
  }

  .info {
    padding: 10px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    box-sizing: border-box;

    .time {
      // font-size: 24px;
      color: $primary;
      margin-bottom: 10px;
    }
  }
}

/deep/.pagination-container {
  padding: 30px 0;
}
</style>